"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toasts = void 0;
const React = __importStar(require("react"));
const react_spring_1 = require("react-spring");
const components_1 = require("@codesandbox/components");
const codesandbox_black_1 = __importDefault(require("@codesandbox/components/lib/themes/codesandbox-black"));
const Portal_1 = __importDefault(require("./Portal"));
const elements_1 = require("./elements");
const state_1 = require("../state");
const Toast_1 = require("./Toast");
const convertMapToToasts = (notifications) => Array.from(notifications.keys()).map(id => ({
    id,
    createdAt: Date.now(),
    notification: notifications.get(id),
}));
const convertNotificationEventToToast = (notificationEvent) => ({
    id: notificationEvent.id,
    createdAt: Date.now(),
    notification: notificationEvent.notification,
});
const isSticky = (toast) => {
    if (toast.notification.status === state_1.NotificationStatus.ERROR &&
        toast.notification.actions) {
        return true;
    }
    if (toast.notification.sticky) {
        return true;
    }
    return false;
};
const TIME_ALIVE = {
    [state_1.NotificationStatus.SUCCESS]: 7000,
    [state_1.NotificationStatus.NOTICE]: 10000,
    [state_1.NotificationStatus.WARNING]: 12000,
    [state_1.NotificationStatus.ERROR]: 20000,
};
const DEFAULT_COLORS = {
    [state_1.NotificationStatus.ERROR]: codesandbox_black_1.default.colors['editorWarning.foreground'],
    [state_1.NotificationStatus.WARNING]: '#F69935',
    [state_1.NotificationStatus.SUCCESS]: codesandbox_black_1.default.colors['terminal.ansiGreen'],
    [state_1.NotificationStatus.NOTICE]: codesandbox_black_1.default.colors['button.background'],
};
function Toasts({ state, colors = DEFAULT_COLORS, Button = components_1.Button, }) {
    const [refMap] = React.useState(() => new WeakMap());
    const mouseOverRef = React.useRef(false);
    const [notificationsToShow, setNotificationsToShow] = React.useState(convertMapToToasts(state.getNotifications()));
    const removeNotification = React.useCallback((id) => {
        setNotificationsToShow(notifs => {
            const newNotifs = notifs.filter(notif => notif.id !== id);
            const notifToHide = notifs.find(notif => notif.id === id);
            if (newNotifs.length !== notifs.length) {
                return newNotifs;
            }
            if (notifToHide && notifToHide.notification.onHide) {
                notifToHide.notification.onHide();
            }
            return notifs;
        });
    }, []);
    React.useEffect(() => {
        const interval = setInterval(() => {
            setNotificationsToShow(notifs => {
                if (mouseOverRef.current) {
                    // Don't remove notifs if there is a mouse there
                    return notifs;
                }
                const newNotifs = notifs.filter(notif => isSticky(notif) ||
                    Date.now() <
                        notif.createdAt +
                            (notif.notification.timeAlive ||
                                TIME_ALIVE[notif.notification.status]));
                if (newNotifs.length !== notifs.length) {
                    return newNotifs;
                }
                return notifs;
            });
        }, 100);
        return () => {
            clearInterval(interval);
        };
    }, []);
    React.useEffect(() => {
        const addListener = state.onNotificationUpdated(event => {
            if (event.type === state_1.NotificationChange.ADD) {
                setNotificationsToShow(notifications => [
                    ...notifications,
                    convertNotificationEventToToast(event),
                ]);
            }
        });
        return () => {
            addListener();
        };
    }, [state]);
    React.useEffect(() => {
        const removeListener = state.onNotificationRemoved(event => {
            setNotificationsToShow(notifications => notifications.filter(n => n.id !== event.id));
        });
        return () => {
            removeListener();
        };
    }, [state]);
    const transitions = react_spring_1.useTransition(notificationsToShow, n => n.id, {
        from: { opacity: 0, height: 0 },
        // @ts-ignore: not typed properly in react-spring
        enter: item => next => next({
            opacity: 1,
            height: refMap.get(item) ? refMap.get(item).offsetHeight + 16 : 0,
        }),
        leave: { opacity: 0, height: 0 },
    });
    return (React.createElement(Portal_1.default, null,
        React.createElement(components_1.ThemeProvider, { theme: codesandbox_black_1.default },
            React.createElement(elements_1.NotificationContainer, { onMouseEnter: () => {
                    mouseOverRef.current = true;
                }, onMouseLeave: () => {
                    mouseOverRef.current = false;
                } }, transitions.map(({ item, props, key }) => (React.createElement(react_spring_1.animated.div, { key: key, style: props },
                React.createElement(Toast_1.Toast, { Button: Button, colors: colors, getRef: ref => ref && refMap.set(item, ref), toast: item, removeToast: (id) => {
                        removeNotification(id);
                    } }))))))));
}
exports.Toasts = Toasts;
